export interface MagentoSalesOrderStatusHistory {
  comment: string;
  created_at: string;
  entity_id: number;
  entity_name: string;
  is_customer_notified: string;
  is_visible_on_front: number;
  parent_id: number;
  status: string;
}
